export const ExcusableExcelHeader = [
  {
    header: "REF NO",
    key: "REF NO",
    width: 25,
  },
  {
    header: "CUSTOMER NAME",
    key: "CUSTOMER NAME",
  },
  {
    header: "REQUEST DATE",
    key: "REQUEST DATE",
  },
  {
    header: "PN",
    key: "PN",
  },
  {
    header: "SN",
    key: "SN",
  },
  {
    header: "FORWARD DATE",
    key: "FORWARD DATE",
  },
  {
    header: "ESTIMATED DATE",
    key: "ESTIMATED DATE",
  },
  {
    header: "SHIPPING TYPE",
    key: "UNPROPER PACKING",
  },
  {
    header: "CREATED BY",
    key: "CREATED BY",
  },
  {
    header: "CREATED DATE",
    key: "CREATED DATE",
  },
  {
    header: "REQUESTED DELIVERY DATE",
    key: "REQUESTED DELIVERY DATE",
  },
  {
    header: "STATUS",
    key: "STATUS",
  },
];

export const ExcusableExcelName = "Excusable List";
